import React, { useRef } from "react";
// import history from "../RouterWithAcess/history";
// import Navbar from "../Navbar";
import { Toast } from "primereact/toast"
import { InputTextarea } from "primereact/inputtextarea";
import { TabView, TabPanel } from "primereact/tabview";
import { Calendar } from "primereact/calendar";
import { questionTypeMapping } from "../../utils/common"
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import async from "../../utils/service.js";
import { Card } from "primereact/card";
import AddOption from "./AddOption";
// import moment from "moment"
import { BreadCrumb } from "primereact/breadcrumb";
import { useNavigate } from "react-router-dom";


function AddPoll() {
  const navigate = useNavigate
  const channelNode = useRef(null);
  const myToast = useRef(null);
  // const showSuccessToast = (header, content) => {
  //   myToast.current.show({severity : 'success', summary : header, detail : content, life : 10000})
  // }
  const showWarningToast = (header, content) => {
    myToast.current.show({severity : "warn", summary : header, detail : content, life : 10000})
  }
  const showErrorToast = (header, content) => {
    myToast.current.show({severity : "error", summary : header, detail : content})
  }

  // const [refresh, setRefresh] = React.useState(false)
  // const [success, setSuccess] = React.useState();
  const [regionList, setRegionList] = React.useState([]);
  const [channelList, setChannelList] = React.useState([]);
  const [chanRegmapping, setCRMapping] = React.useState({});
  // const [buttonClick, setBClick] = React.useState(false)

  const items = [
    { label: "Poll", url: "/Poll" },
    {
      label:
        "Add Poll" 
    },
  ];

  const home = {
    icon: "pi pi-home",
    url: "/",
  };


  const initialQuestion = {
    questionType: "Radio Type",
    questionName: "",
    options: [{ optionText: "", minRange: null, maxRange: null},
     { optionText: "", minRange: null, maxRange: null}],
    channels: [],
    regions: [],
    channelQuestions: []
  };

  const intialPoll = {
    surveyStartDate: "",
    surveyEndDate: "",
    questions: [initialQuestion],
  }

  const addTodayDate = (num) => {
    var date = new Date()
    date.setDate(date.getDate() + num)
    return date
  }
  
  const [createPoll, setCreatePoll] = React.useState(intialPoll);

  const [viewEndDate, setViewEndDate] = React.useState(addTodayDate(0))

  const questionTypeList = ["Radio Type", "Checkbox", "Range Type"];

  
  const handleStartDateChange = (e) => {
    setCreatePoll({...createPoll ,surveyStartDate : e.value})
    // var date = new Date(e.value)
    // date.setDate(date.getDate() + 1)
    // setViewEndDate(date)
  }

  const createJSON = () => {
    var AddSurveyJSON = {}
    var start_date = createPoll.surveyStartDate
    var end_date = createPoll.surveyEndDate

    AddSurveyJSON.surveyStartDate = start_date.getFullYear() + "-"
    AddSurveyJSON.surveyEndDate = end_date.getFullYear() + "-"

    if (start_date.getMonth() < 9){
      AddSurveyJSON.surveyStartDate+="0"
    }
    if (end_date.getMonth() < 9){
      AddSurveyJSON.surveyEndDate+="0"
    }
    AddSurveyJSON.surveyStartDate += (start_date.getMonth() + 1) + "-"
    AddSurveyJSON.surveyEndDate += (end_date.getMonth() + 1) + "-"
    if (start_date.getDate() < 10){
      AddSurveyJSON.surveyStartDate+="0"
    }
    if (end_date.getDate() < 10){
      AddSurveyJSON.surveyEndDate+="0"
    }
    AddSurveyJSON.surveyStartDate+=start_date.getDate()
    AddSurveyJSON.surveyEndDate+=end_date.getDate()
    // AddSurveyJSON.surveyStartDate = start_date
    // AddSurveyJSON.surveyEndDate = end_date
    AddSurveyJSON.surveyType = "Type"
    AddSurveyJSON.surveyDescription = "SurveyDescription"

    var questionList = JSON.parse(JSON.stringify(createPoll.questions))
    for (var i=0;i<questionList.length;i++){
      var chanques = []
      const quesChannels = questionList[i].channels;
      if (quesChannels.length === 0){ showWarningToast("", "Please select a Channel for Question "+(i+1)); return {}}
      const quesRegions = questionList[i].regions;
      if (quesRegions.length === 0){ showWarningToast("", "Please select a Region for Question "+(i+1)); return {}}

      for (var chid=0; chid<quesChannels.length;chid++){
        for (var regid=0; regid<quesRegions.length ;regid++){
          if (chanRegmapping[quesChannels[chid]].includes(quesRegions[regid])){
            chanques.push({channelId : quesChannels[chid], regionId : quesRegions[regid]})
          }
        } 
      }
      questionList[i]["channelQuestions"] = chanques
      questionList[i]["questionType"] = questionTypeMapping[questionList[i].questionType]
      // questionList[i]["questionStatus"] = null

      delete questionList[i]["channels"]
      delete questionList[i]["regions"]

      if (questionList[i].questionType === "SLIDER"){
        for (var opid=0;opid < questionList[i].options.length; opid++){
          if(questionList[i].options[opid].minRange === null && questionList[i].options[opid].maxRange === null){
            questionList[i]["options"].splice(opid, 1)
          }
        }
      }

    }
    AddSurveyJSON.questions = questionList

    return AddSurveyJSON
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    // if (new Date(createPoll.surveyStartDate) > new Date(createPoll.surveyEndDate)){
    //   showWarningToast("Wrong period", "End date should be after start date")
    // }
    // else{
    const SurveyJson = createJSON()
    if (JSON.stringify(SurveyJson) === JSON.stringify({}) ){return}

    // setCreatePoll(intialPoll)
    // setRefresh(true)
    async.saveorUpdateSurvey(SurveyJson)
    .then(resp => {
      if (resp.data === "Success"){
        // showSuccessToast("Succcess", "Survey created succesfully")
        navigate("/poll")
      }
      else {
        showWarningToast("Request Failed", "Survey with same period exists")
      }
      // setCreatePoll(prevPoll => ({...prevPoll, questions : [initialQuestion]}))
      // showSuccessToast("Sent sucessfullt", "Nothing yet")
      // setRefresh(true)
    })
    .catch((error) => {
      showErrorToast("Request Failed", "Please try again")
      // setRefresh(true)
    })
    // }
  };

  const deleteQuestion = (index) => {
    const questionList = [...createPoll.questions];
    questionList.splice(index, 1);
    setCreatePoll({ ...createPoll, questions: questionList });
  };

  const addQuestion = () => {
    setCreatePoll({
      ...createPoll,
      questions: [...createPoll.questions, initialQuestion],
    });
  };

  function handleQuestionChange(event, index) {
    let name = event.target.name;
    const questionList = [...createPoll.questions];
    questionList[index][name] = event.target.value;
    setCreatePoll({
      ...createPoll,
      questions: questionList,
    });
  }

  const deleteOption = (optionId, index) => {
    const questionList = [...createPoll.questions];
    questionList[index].options.splice(optionId, 1);
    setCreatePoll({ ...createPoll, questions: questionList });
  };

  const addOption = (index) => {
    const questionList = [...createPoll.questions];
    questionList[index].options = [
      ...questionList[index].options,
      {optionText: ""},
    ];
    setCreatePoll({
      ...createPoll,
      questions: questionList,
    });
  };

  const handleOptionChange = (event, optionId, index) => {
    const questionList = [...createPoll.questions];
    if (questionList[index].questionType === "Range Type"){
      if (optionId === 0){
        questionList[index].options[0].minRange = event.target.value
        
      }
      else{
        questionList[index].options[0].maxRange = event.target.value
      }
    }
    else{
      questionList[index].options[optionId].optionText = event.target.value;
    }

    setCreatePoll({
      ...createPoll,
      questions: questionList,
    });
  };

  React.useEffect(() => {
    async.getRegionCountry().then((response) => {
      var chanData = response.data.availableChannels
      var temp_mapping = {}
      for (var i=0;i<chanData.length;i++){
        temp_mapping[chanData[i].channelId] = chanData[i].regions.map(item => item.regionId)
      }
      setCRMapping(temp_mapping)
    });
    async.getChannels().then(resp => {
      setChannelList(resp.data)
      async.getChannelRegions().then(resp => {
        setRegionList(resp.data)
      })
    })
  }, []);
  return (
    <div>
      {/* <Navbar /> */}
      <div className="app__grid">
      <BreadCrumb model={items} home={home} />
        <TabView>
          <TabPanel header="Create New Survey"></TabPanel>
        </TabView>
        <form onSubmit={handleSubmit} id="poll">
          <div className="p-fluid formgrid grid mt-3">
            <div className="field col md:col-3 sm:col-12">
              <label htmlFor="firstname" className="label">
                * Start Date
              </label>
              <Calendar
                dateFormat="MM d, yy"
                name="surveyStartDate"
                // readOnlyInput
                value={createPoll.surveyStartDate}
                // onInput={(e) => {
                //   setCreatePoll((prevPoll) => ({...createPoll, surveyStartDate : prevPoll.surveyStartDate}))
                // }}
                // onInput = {(e) => }
                // placeholder = "dd/mm/yyyy"
                onChange={(e) =>
                  handleStartDateChange(e)
                }
                viewDate = {addTodayDate(0)}
                minDate = {addTodayDate(0)}
                showIcon
                // readOnlyInput
                required
                showOtherMonths={false}
              />
            </div>
            <div className="field col md:col-3 sm:col-12">
              <label htmlFor="firstname" className="label">
                * End Date
              </label>
              <Calendar
                dateFormat="MM d, yy"
                name="surveyEndDate"
                // placeholder = "dd/mm/yyyy"
                // readOnlyInput
                value={createPoll.surveyEndDate}
                onChange={(e) =>
                  setCreatePoll({ ...createPoll, surveyEndDate: e.value })
                }
                viewDate = {viewEndDate}
                onViewDateChange = {(e) => setViewEndDate(e.value)}
                minDate={viewEndDate}
                showIcon
                required
                showOtherMonths={false}
              />
            </div>
          </div>

          {createPoll.questions.map((question, index) => (
            <Card key={index} className="questionCard">
              <b>Question {index + 1}</b>
              <div className="p-fluid formgrid grid ">
                <div className="field col md:col-4 sm:col-12">
                  <label className="label">* Channel</label>
                  <MultiSelect
                    ref = {channelNode}
                    name="channels"
                    value={question.channels}
                    options={channelList}
                    optionLabel="channelName"
                    optionValue="channelId"
                    selectedItemsLabel="{0} channels selected"
                    onChange={(e) => handleQuestionChange(e, index)}
                    // required={true}
                    // checkValidity = {() => {return question.channels.length > 0}}
                  />
                </div>

                <div className="field col md:col-4 sm:col-12">
                  <label htmlFor="zip" className="label">
                      * Region
                  </label>
                  <MultiSelect
                    name="regions"
                    value={question.regions}
                    options={regionList}
                    optionLabel="region"
                    optionValue="regionId"
                    selectedItemsLabel="{0} regions selected"
                    onChange={(e) => handleQuestionChange(e, index)}
                    // required
                  />
                </div>
                <div className="field col md:col-4 sm:col-12">
                  <label className="label">* Question type</label>
                  <Dropdown
                    name="questionType"
                    value={question.questionType}
                    options={questionTypeList}
                    onChange={(e) => handleQuestionChange(e, index)}
                    required
                  />
                </div>
                <div className="field col md:col-10 sm:col-12">
                  <label htmlFor="firstname" className="label">
                    * Question Text
                  </label>
                  <InputTextarea
                    rows={2}
                    cols={30}
                    name="questionName"
                    value={question.questionName}
                    onChange={(e) => handleQuestionChange(e, index)}
                    required
                  />
                </div>
                <AddOption
                  index={index}
                  addOption={addOption}
                  question={question}
                  handleOptionChange={handleOptionChange}
                  deleteOption={deleteOption}
                />

                <div className="field block mx-auto sm:col-12 ">
                  <Button
                    onClick={addQuestion}
                    label="Add another question"
                    className="p-button-sm btn3"
                    type="button"
                  />
                  {
                    createPoll.questions.length > 1 &&
                    <Button
                      label="Delete question"
                      className="p-button-sm btn3"
                      onClick={(e) => deleteQuestion(index)}
                      type="button"
                    />
                  }
                </div>
              </div>
            </Card>
          ))}
          <Button
            type="submit"
            form="poll"
            label="Save"
            className="p-button-sm btn2 "
          />
        </form>
        <Toast ref={myToast} baseZIndex={20000}/>
      </div>
    </div>
  );
}

export default AddPoll;
